export const POPULAR_CHIPS = [
  "Full Body Checkup",
  "Thyroid Profile",
  "Diabetes",
  "Vitamin D",
  "CBC",
  "HbA1c",
];
